import { render, staticRenderFns } from "./selectDimensionModal.vue?vue&type=template&id=26f29fe9"
import script from "./selectDimensionModal.vue?vue&type=script&lang=js"
export * from "./selectDimensionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports